import React from 'react';
import { motion } from 'framer-motion';
import { Compass, Sparkles, LockKeyhole, CalendarClock } from 'lucide-react';
export function ValidationSection() {
  const badges = [{
    icon: <Compass size={28} strokeWidth={1.5} data-id="element-352" />,
    text: 'Proceso guiado'
  }, {
    icon: <Sparkles size={28} strokeWidth={1.5} data-id="element-353" />,
    text: 'Acciones simples'
  }, {
    icon: <LockKeyhole size={28} strokeWidth={1.5} data-id="element-354" />,
    text: 'Formato privado'
  }, {
    icon: <CalendarClock size={28} strokeWidth={1.5} data-id="element-355" />,
    text: 'Enfoque de 21 días'
  }];
  return <section className="py-16 px-4 bg-cream border-y border-soft/30" data-id="element-356">
      <div className="max-w-4xl mx-auto text-center" data-id="element-357">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-10" data-id="element-358">
          {badges.map((badge, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-359">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-white to-blush flex items-center justify-center text-primary mb-4 shadow-md border border-soft/40" data-id="element-360">
                {badge.icon}
              </div>
              <span className="text-sm font-sans font-bold text-primary leading-tight" data-id="element-361">
                {badge.text}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-ink/75 font-sans text-base md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-362">
          Este no es un libro de teoría interminable. Es un{' '}
          <span className="font-bold text-primary" data-id="element-363">
            acompañamiento personal y práctico
          </span>{' '}
          diseñado para que tomes acción emocional desde el día 1, en la
          intimidad de tu espacio.
        </motion.p>
      </div>
    </section>;
}